module.exports = __webpack_public_path__ + "img/redness_0.6ab3a056.png";